export const ENV = 'app';
export const URL_PREFIX = 'app.';
export const S3_BUCKET = 'https://web-platform-data-dev.s3.ap-northeast-2.amazonaws.com/';
export const SUPPORT_EMAIL = 'hello@luxolis.ai';
export const PRIVACY_EMAIL = 'hello@luxolis.ai';
export const BACKEND_URL = 'https://api.app.o-hive.ai/'
export const PAYPAL_CLIENT_ID = 'AQH7I6sbYqOEWCrIz18VFuX5WQY-zVDARQqSuu-5GhlA0WpwuAAh0j-R3px0zBJJSfxukfq6PCQaERE6';
export const DETECTION_API_URL = 'https://detection.o-hive.ai';
export const RTMP_API_HOST = 'api.rtmp.o-hive.ai';
export const RTMP_HTTP_FLV_HOST = 'rtmp.o-hive.ai';
export const RTMP_API_PORT = 3001;
export const RTMP_HTTP_PORT = 8000;
